import React from "react";

import { Button } from "aible";
import Select from "react-select";

import AibleStep from "containers/CreateWizard/AibleStep";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import SuccessContainer from "containers/CreateWizard/Success/Success";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import styles from "./style.module.css";

export default class RelatedSuccess extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplitColumn: false
    };
  }

  renderValueTable(group) {
    const { editSplitColumn, deleteSplitColumn } = this.props;

    const headers = ["Include", "Value", "Count"];

    const rows = Object.keys(group.fields).map((f, index) => {
      const value = group.fields[f];
      const isIncluded = value.isIncluded;

      return {
        data: [value.value, value.count],
        row: (
          <TableRow className={styles.fieldRow} key={index} style={{ opacity: !isIncluded ? 0.5 : 1.0 }}>
            <TableColumn>
              <div className={styles.ignoreHolder}>
                <input
                  type="checkbox"
                  checked={isIncluded}
                  onChange={() => editSplitColumn(group.id, value.value, !isIncluded)}
                />
              </div>
            </TableColumn>
            <TableColumn>{value.value}</TableColumn>
            <TableColumn>{value.count}</TableColumn>
          </TableRow>
        )
      };
    });

    const includedFields = Object.values(group.fields)
      .map((elem) => (elem.isIncluded ? elem.value : ""))
      .filter((elem) => elem);

    return (
      <div className={styles.valueTable} key={group.id}>
        <div className={styles.vLabel}>
          {includedFields.length > 0 ? "Split on " + includedFields.join(", ") : "Group " + (group.id + 1)}
        </div>
        <div className={styles.vHolder}>
          <TableLoader autoHeight={true} headers={headers} rows={rows} hideSearch={true} minHeight={"160px"} />
        </div>
        <div className={styles.vDelete} onClick={() => deleteSplitColumn(group.id)}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    );
  }

  renderSplitColumn() {
    const { selectedDataset, splitColumn, addSplitColumn, updateSplitColumn } = this.props;
    const { showSplitColumn } = this.state;

    return (
      <div className={styles.sCols}>
        <AibleStep
          message="Sometimes it is useful to have specialized models for different subgroups such as geographies or products. Would you like to create such models?"
          secondaryMessage="You can split based on any one column, and choose different groups to focus models on."
        />
        <div className={styles.priceColumn + " " + styles.splitModel}>
          {showSplitColumn === false ? (
            <a onClick={() => this.setState({ showSplitColumn: true })}>{"Create Model Split"}</a>
          ) : (
            <a
              onClick={() => {
                this.setState({ showSplitColumn: false });
                updateSplitColumn(undefined);
              }}
            >
              {"Remove Model Split"}
            </a>
          )}
          {selectedDataset && selectedDataset.fields && showSplitColumn && (
            <div
              style={{
                width: "400px",
                marginTop: "10px",
                position: "relative",
                zIndex: "1000"
              }}
            >
              <Select
                options={Object.keys(selectedDataset.fields)
                  .filter((f) => selectedDataset.fields[f].type === "categorical")
                  .map((f) => ({
                    label: f,
                    value: f
                  }))}
                value={
                  splitColumn
                    ? {
                        label: splitColumn.column,
                        value: splitColumn.column
                      }
                    : undefined
                }
                onChange={(val) => updateSplitColumn(val.value)}
                menuPlacement="top"
                placeholder={"Select Column to split on"}
              />
            </div>
          )}
          {splitColumn && splitColumn.column && splitColumn.splitGroups ? (
            <div className={styles.splitGroupWrapper}>
              {Object.keys(splitColumn.splitGroups).map((g) => this.renderValueTable(splitColumn.splitGroups[g]))}
              <div className={styles.splitButton}>
                <Button type="secondary" onClick={() => addSplitColumn()}>
                  {"Add new Split Group"}
                </Button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  render() {
    const { id, updateRelatedId, relatedId, relatedJobs, hasSplit, blueprintId } = this.props;

    return (
      <div>
        <SuccessContainer
          {...this.props}
          blueprintId={blueprintId}
          id={relatedId ? relatedId : id}
          originalId={id}
          index={500}
        />
      </div>
    );
  }
}
